module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2cHsO"))).then(() => parcelRequire('hEqeo'));